export default "__VITE_ASSET__ipjeBhX6__"